import { createAsyncThunk } from "@reduxjs/toolkit";
import { SubscriptionProcessStep } from "features/subscription-process/types/interfaces";

export const nextStep = createAsyncThunk(
  'subscriptionProcess/nextStep',
  async (entity: SubscriptionProcessStep) => {
    return entity;
  }
);
